import * as $ from 'jquery';
import 'bootstrap';
import * as Cookies from 'js-cookie';
import { headerContent } from './c002';

export class alertContainer{
	$alertContainer: any          = $('#alert-container');
	$mabHeader: any               = $('#mab-header');
	$slideMenu: any               = $('#slidemenu');

	$alertMsgList: any            = this.$alertContainer.find('ul');
	$alertMsgs: any               = this.$alertContainer.find('li.alert-content');
	$closeAlertBtn: any           = this.$alertContainer.find('.alert-close');

	$alertExists: string          = 'alert-exists';
	$alertLoopInterval: number    = parseInt(this.$alertContainer[0].dataset.interval);
	$alertTransitionSpeed: number = 350;
	$alertHeight: number;

	$alertCookieName: string      = 'MAB-Site-hide-alerts';
	$alertCookieExpiry: number    = parseInt(this.$alertContainer[0].dataset.expiry);

	private headercontent = new headerContent();
	/**
	 * Close button handler for alert container
	 * Close alert container when close button is clicked
	 * Set cookie to user to save hidden alert state
	 * @return {any} [description]
	 */
	closeContainer(): void {

		let _self = this;

		if(!_self.$alertContainer.length) { return; }

		_self.$closeAlertBtn.on('click', () => {
				_self.$alertContainer.fadeOut(500);
				_self.$mabHeader.addClass(_self.$alertExists);
				_self.$slideMenu.addClass(_self.$alertExists);

				// set cookie for hiding alert container for period of time
				// Cookies.set(_self.$alertCookieName, 'true', { expires: _self.$alertCookieExpiry });
				Cookies.set(_self.$alertCookieName, 'true');

				setTimeout(() => {
					_self.headercontent.calcMainnavOffset();
				}, 1800);
				_self.$alertContainer.parent().parent().parent().hide();
		});

		if (_self.$alertContainer.css('display') == 'none' ){
			_self.$mabHeader.addClass(_self.$alertExists);
		} else {
			_self.$mabHeader.removeClass(_self.$alertExists);
		}
	}

	/**
	 * Initialize alert container
	 * Loop alert contents if more than 1 items are exists
	 * check if hidden cookie is present. Do not show alert div if present.
	 * @return {any} [description]
	 */
	initAlertComponent(): void {
		let _self = this;

		// if hidden cookie is not present, show alert div
		if (!Cookies.get(_self.$alertCookieName)) {
				// console.log(_self.$alertContainer);
				_self.$alertContainer.show();

		} else {
			// exit function if alert component is hidden
			return;
		}

		// if alert container only contains one alert, do nothing
		if (!_self.$alertContainer.length) { return;}

		// init loop on alert contents if more than 1 alert message exists
		if (_self.$alertMsgs.length >  1){

			let currMsg:any     = _self.$alertContainer.find('ul li:first-child');
			let currMsgSize:any = _self.calcCurrentDimensions(currMsg);

			// init alert container height to be height of first content div
			_self.$alertContainer.css({
				display: 'block',
				height: currMsgSize.height
			});

			_self.headercontent.calcMainnavOffset();

			// init looping function
			setInterval(function () {
				_self.alertMsgTransition();
			}, _self.$alertLoopInterval);

			// window resize handler
			// reset height of container based on content height
			$(window).resize(function() {
				let currMsg: any     = _self.$alertContainer.find('ul li:first-child');
				let currMsgSize: any = _self.calcCurrentDimensions(currMsg);

				_self.$alertContainer.css({
					height: currMsgSize.height
				});

				_self.headercontent.calcMainnavOffset();
			})
		}
	}

	/**
	 * Transition between alert messages
	 * @return {any} [description]
	 */
	alertMsgTransition(): void {
		let _self = this;

		// clear inline currently set inline width
		_self.$alertContainer.css({
			width: ''
		});

		let lastMsg:any     = _self.$alertContainer.find('ul li:last-child');
		let lastMsgSize:any = _self.calcCurrentDimensions(lastMsg);

		//console.log(lastMsgSize.height, _self.$alertContainer.outerHeight());

		_self.$alertMsgList.animate({
			opacity: 0
		}, _self.$alertTransitionSpeed, function () {
			// console.log(lastMsg, lastMsgSize);
			lastMsg.prependTo(_self.$alertMsgList);
			_self.$alertMsgList.animate({
				'opacity': 1
			}, _self.$alertTransitionSpeed);

			// expand height only if new message is bigger than currently displayed
			if (lastMsgSize.height > _self.$alertContainer.outerHeight()) {
				_self.$alertContainer.animate({
					'height': lastMsgSize.height
				}, _self.$alertTransitionSpeed);
			}
		});
	}

	/**
	 * calculate dimensions of message and return width + height values
	 * @param  {any} el [element to get width/height]
	 * @return {any}    [description]
	 */
	calcCurrentDimensions(el:any): any {
		let _self = this;
		let offsetVal:number = 25;
		let dimensionObj: any = {
			width: 0,
			height: 0
		}

		dimensionObj.width = el.width() + offsetVal;
		dimensionObj.height = el.height() + offsetVal - 5;

		return dimensionObj;
	}
}
let scope:Element = document.querySelector('#alert-container');
if (scope){
	try {
		let alertcontainer = new alertContainer();
		alertcontainer.closeContainer();
		alertcontainer.initAlertComponent();
	} catch(e) {console.error(e);}
}
